import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useTheme } from '../contexts/ThemeContext';
interface WeeklySalesData {
  kw: number;
  jahr: number;
  erstgesprächeVereinbart: number;
  erstgesprächeErschienen: number;
  qualifiziert: number;
  verkaufsgesprächeVereinbart: number;
  verkaufsgesprächeErschienen: number;
  abschlüsse: number;
}
interface SalesChartProps {
  weeklyData: WeeklySalesData[];
  selectedView: 'summary' | number;
}
export function SalesChart({
  weeklyData,
  selectedView
}: SalesChartProps) {
  const {
    theme
  } = useTheme();
  const chartData = weeklyData.map(week => ({
    name: `KW ${week.kw}`,
    vereinbart: week.erstgesprächeVereinbart,
    erschienen: week.erstgesprächeErschienen,
    qualifiziert: week.qualifiziert,
    abschlüsse: week.abschlüsse
  }));
  return <div className={`rounded-xl border p-6 ${theme === 'dark' ? 'bg-[#1f1f1f] border-[#2a2a2a]' : 'bg-white border-gray-200'}`} data-id="element-42">
      <div className="flex items-center justify-between mb-6" data-id="element-43">
        <div data-id="element-44">
          <h3 className={`text-lg font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-black'}`} data-id="element-45">
            {selectedView === 'summary' ? 'Verlauf über alle Wochen' : `Detailansicht KW ${selectedView}`}
          </h3>
          <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-46">
            Entwicklung der Kennzahlen
          </p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300} data-id="element-47">
        <AreaChart data={chartData} data-id="element-48">
          <defs data-id="element-49">
            <linearGradient id="colorVereinbart" x1="0" y1="0" x2="0" y2="1" data-id="element-50">
              <stop offset="5%" stopColor="#9CA3AF" stopOpacity={0.8} data-id="element-51" />
              <stop offset="95%" stopColor="#9CA3AF" stopOpacity={0.1} data-id="element-52" />
            </linearGradient>
            <linearGradient id="colorErschienen" x1="0" y1="0" x2="0" y2="1" data-id="element-53">
              <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.8} data-id="element-54" />
              <stop offset="95%" stopColor="#3B82F6" stopOpacity={0.1} data-id="element-55" />
            </linearGradient>
            <linearGradient id="colorAbschlüsse" x1="0" y1="0" x2="0" y2="1" data-id="element-56">
              <stop offset="5%" stopColor="#10B981" stopOpacity={0.8} data-id="element-57" />
              <stop offset="95%" stopColor="#10B981" stopOpacity={0.1} data-id="element-58" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke={theme === 'dark' ? '#2a2a2a' : '#e5e7eb'} data-id="element-59" />
          <XAxis dataKey="name" stroke={theme === 'dark' ? '#404040' : '#9ca3af'} tick={{
          fill: theme === 'dark' ? '#737373' : '#6b7280'
        }} data-id="element-60" />
          <YAxis stroke={theme === 'dark' ? '#404040' : '#9ca3af'} tick={{
          fill: theme === 'dark' ? '#737373' : '#6b7280'
        }} data-id="element-61" />
          <Tooltip contentStyle={{
          backgroundColor: theme === 'dark' ? '#1f1f1f' : '#ffffff',
          border: `1px solid ${theme === 'dark' ? '#2a2a2a' : '#e5e7eb'}`,
          borderRadius: '8px',
          color: theme === 'dark' ? '#fff' : '#000'
        }} data-id="element-62" />
          <Legend data-id="element-63" />
          <Area type="monotone" dataKey="vereinbart" name="Vereinbart" stroke="#9CA3AF" strokeWidth={2} fillOpacity={1} fill="url(#colorVereinbart)" data-id="element-64" />
          <Area type="monotone" dataKey="erschienen" name="Erschienen" stroke="#3B82F6" strokeWidth={2} fillOpacity={1} fill="url(#colorErschienen)" data-id="element-65" />
          <Area type="monotone" dataKey="abschlüsse" name="Abschlüsse" stroke="#10B981" strokeWidth={2} fillOpacity={1} fill="url(#colorAbschlüsse)" data-id="element-66" />
        </AreaChart>
      </ResponsiveContainer>
    </div>;
}